import { useUser } from '@/store/user'

export const authMiddleware = (to) => {
  if (Object.hasOwnProperty.call(to.meta, 'requireAuth')) {
    const user = useUser()

    if (to.meta.requireAuth && !user.authorized) {
      return { name: 'Login' }
    }
    if (!to.meta.requireAuth && user.authorized) {
      return { name: 'Wallets' }
    }
  }
}
